ko.bindingHandlers.setChecked = {

    init: function (e, va, aba)
    {
        var attr = aba().checkedAttr || 'checked';
        if (ko.unwrap(va())) { e.setAttribute(attr, attr) } else { e.removeAttribute(attr) }
    },
    update: function (e, va, aba)
    {
        var attr = aba().checkedAttr || 'checked';
        if (ko.unwrap(va())) { e.setAttribute(attr, attr) } else { e.removeAttribute(attr) }
    }
}

